import { render, staticRenderFns } from "./building.vue?vue&type=template&id=af47cce4&scoped=true&"
import script from "./building.vue?vue&type=script&lang=js&"
export * from "./building.vue?vue&type=script&lang=js&"
import style0 from "./building.vue?vue&type=style&index=0&id=af47cce4&prod&lang=scss&"
import style1 from "./building.vue?vue&type=style&index=1&id=af47cce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af47cce4",
  null
  
)

export default component.exports